<template>
  <v-row justify="center">
    <div v-if="loading_recibo">
      <v-progress-linear indeterminate />
    </div>
    <v-dialog v-model="dialog" scrollable :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card v-if="recibo && sede">
        <v-toolbar color="primary white--text" flat>
          <v-toolbar-title>Datos del Registro de Pagos:</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <vue-html2pdf 
            :show-layout="true"
            :float-layout="false"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1100"
            filename="recibo"
            :manual-pagination="false"
            pdf-format="letter"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            ref="html2Pdf"   
          >
            <section slot="pdf-content">
              <v-container id="html">
                <div v-if="sede" class="mb-0 pb-0">
                  <!-- <img :src="sede.modelo_recibo" class="img-responsive" /> -->
                  <img :src="getfondoimg()" class="img-responsive" />
                </div>
                <v-row no-gutters class="mb-1 pb-0">
                  <v-col cols="3" class="mb-0 pb-0">
                    <span class="flexitem border-box">
                      <span class="r-box r-title2">
                        Lugar / Sede <br />
                        <!-- {{ isbenitojuarez ? 'Benito Juarez' : sede.nombre_recibo=='Esam Latam'? '':''+sede.nombre_recibo }} -->
                          {{ sede.nombre_recibo }}
                      </span>
                    </span>
                  </v-col>
                  <v-col cols="6" class="text-center mb-0 pb-0">
                    <span class="flexitem recibo-number border-box"> COMPROBANTE N° {{ recibo.numero_recibo }}</span>
                  </v-col>
                  <v-col cols="3" class="text-right mb-0 pb-0">
                    <span class="flexitem border-box">
                      <span class="r-box r-title2">
                        {{ data_rec.fecha }} <br />
                        {{ formatDate(data_rec.valor) }} <br>
                        {{ data_rec.upi_emision }} <br>
                        {{ formatDate(data_rec.upi_emision_fecha) }} 
                      </span> 
                    </span> 
                  </v-col>
                </v-row>
                <div class="flexcontainer pa-1">
                  <span class="flexitem">
                    <span class="r-box r-title2">Forma Pago</span>
                    <span class="r-box r-text"> {{ recibo.forma_pago }} </span>
                  </span>
                  <!-- <span class="flexitem" v-if="recibo.forma_pago_id == 2">
                <span class="r-box r-title2 d-print-none">Fecha de Pago</span> <span class="r-box r-text"> {{ formatDate(recibo.fecha_pago) }} </span>
              </span> -->

                  <span class="flexitem d-print-none" v-if="recibo.numero_factura != '0'">
                    <span class="r-box r-title2">N° Factura</span>
                    <span class="r-box r-text"> {{ recibo.numero_factura }} </span>
                  </span>

                  <!-- <span class="flexitem d-print-none" v-if="sede.cuenta_bancaria">
                <span class="r-box r-title2">Banco/Cuenta </span>
                <span class="r-box r-text"> {{ sede.cuenta_bancaria.nombre }} - {{ sede.cuenta_bancaria.nro }}</span>
              </span> -->
                  <span class="flexitem" v-if="programa">
                    <span class="r-box r-title2">{{ gettext_posgrado() }} </span>
                    <span class="r-box r-text"> {{ programa.nombre_compuesto }} </span>
                  </span>
                  <span class="flexitem" v-if="estudiante">
                    <span class="r-box r-title2">Estudiante</span>
                    <span class="r-box r-text">
                      {{ estudiante.pri_apellido }}
                      {{ estudiante.seg_apellido }}
                      {{ estudiante.nombres }} -
                      {{ estudiante.num_doc }}
                    </span>
                  </span>
                  <span class="flexitem">
                    <span class="r-box r-title2">Señor(a) Depositante</span>
                    <span class="r-box r-text">
                      {{ recibo.nombre_depositante }}
                      {{ recibo.numero_documento_depositante ? ' - ' + recibo.numero_documento_depositante : '' }}
                    </span>
                  </span>
                </div>
                <div v-show="!recibo.estado" class="rotate text-center">
                  <p class="anulado">RECIBO ANULADO</p>
                </div>
                <table class="item-table" :style="getStylePrint()">
                  <thead style="text-align:center">
                    <th style="text-align:center;width:2em" class="item-th"></th>
                    <th style="text-align:center" class="item-th">Concepto</th>
                    <th style="text-align:center;width:3em" class="item-th">N° de Cuota</th>
                    <th style="text-align:center;width:6em" class="item-th">Cantidad</th>
                    <th style="text-align:center" class="item-th" v-if="recibo.existedescuento">Importe</th>
                    <th style="text-align:center" class="item-th" v-if="recibo.existedescuento">Descuento</th>
                    <th style="text-align:center;width:5em" class="item-th">Monto</th>
                    <th style="text-align:center;width:5em" class="item-th">Subtotal</th>
                    <th style="text-align:center;width:6em" class="item-th">Unidad Medidad</th>
                  </thead>
                  <tbody class="">
                    <tr class="item-tr" v-for="(item, index) in items" :key="item.id">
                      <td class="item-td">{{ index + 1 }}</td>
                      <td class="item-td">{{ capitalize(item.concepto_name) }}</td>
                      <td class="item-td">{{ item.numero_cuota }}</td>
                      <td class="item-td">{{ item.cantidad }}</td>
                      <td v-if="recibo.existedescuento" class="item-td">{{ item.importe }}</td>
                      <td v-if="recibo.existedescuento" class="item-td text-center">{{ item.descuento }}</td>
                      <td class="item-td text-center">{{ item.monto }}</td>
                      <td class="item-td text-center">{{ item.subtotal }}</td>
                      <td class="item-td text-center">{{ item.unidad_medida_abreviatura }}</td>
                    </tr>
                    <tr class="item-tr">
                      <td :colspan="recibo.existedescuento ? 8 : 6" class="text-right">Total ({{ getMonedaStr() }})</td>
                      <td class="item-td text-center">{{ fixeddecimal(recibo.total) }}</td>
                    </tr>
                    <tr class="item-tr">
                      <td :colspan="recibo.existedescuento ? 9 : 7" class="text-right">
                        <span class="">
                          Son {{ literal }} {{ getMonedaStr() }} <strong> {{ fixeddecimal(recibo.total) }}/00</strong>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <v-row dense align-content="center">
                  <v-col cols="1"></v-col>
                  <v-col cols="4" v-if="asesor" class="mb-0 pb-0 text-center">
                    <div class="firma-box">
                      <img :src="firma_path + asesor.firma" v-if="asesor.firma" class="firma-responsive" width="180" />
                    </div>
                    <span class="r-title3 py-0 my-0">Emisor</span>
                    <span class="r-title3 py-0 my-0">
                      {{ asesor.datos_personales.pri_apellido }}
                      {{ asesor.datos_personales.seg_apellido }}
                      {{ asesor.datos_personales.nombres }}
                    </span>
                    <span v-if="asesor" class="r-title3 py-0 my-0">{{
                      asesor.cargo ? asesor.cargo.nombre : '----'
                    }}</span>
                  </v-col>
                  <v-col cols="2"> </v-col>
                  <v-col cols="4" v-if="asesor" class="mb-0 pb-0 text-center">
                    <div class="firma-box">
                      <!-- <img :src="firma_path + asesor.firma" class="firma-responsive" width="180" /> -->
                    </div>
                    <span class="r-title3 py-0 my-0">Depositante</span>
                    <span class="r-title3 py-0 my-0">{{ recibo.nombre_depositante }}</span>
                    <span class="r-title3 py-0 my-0">N° Doc: {{ recibo.numero_documento_depositante }}</span>
                  </v-col>
                </v-row>

                <div v-if="isvisibledir">
                  <p class="mb-0" style="margin-bottom:0"><b>Direccion:</b> {{ sede.direccion }}</p>
                  <p class="mb-0"><b>cel:</b> {{ sede.telefono1 }}</p>
                </div>
              </v-container>
            </section>
          </vue-html2pdf>

          <p v-if="puedeModificar" class="green--text mb-0 text-center">
            Puede modificar el recibo hasta pasado un mes despues de haber sido emitido el recibo
          </p>

          <p class="my-0 text-center">
            <b>{{ xnit }}</b>
          </p>
          <!-- <p v-if="!puedefacturar" class="green--text ma-0 pa-0">
            <small>Este recibo no es facturable</small>
          </p> -->
          <p class="my-0 text-center">
            <b>{{ msgnofact }}</b>
          </p> 
          <p class="text-center red--text">{{ msgfact }}</p>

          <div>
            <p class="my-0 py-0"> 
              <b>Unida de negocio:</b>
              <span v-if="$store.state.CARGO && $store.state.CARGO.sede">
                {{ $store.state.CARGO.sede.unidad_negocio }}
              </span>
            </p>
          </div>

          <v-progress-linear color="green" indeterminate v-if="verifynit" />
        </v-card-text>
        <v-card-actions v-if="recibo.estado">
          <div v-if="msgnofact.length == -1" class="mr-2">
            <span>Para descargar debe generar factura </span>
          </div>
          <!-- <div v-if="nitelectronico && !recibo.factura_id && msgnofact.length == 0" class="mr-2">
            <span>Para descargar debe generar factura e. </span>
          </div> -->
          <v-btn
            :disabled="$store.state.isonlyread"
            v-else-if="puedeImprimir && $store.state.CARGO.id!=27"
            color="red lighten-2"
            :loading="loading"
            small
            rounded
            @click="generateReport"
          >
            <v-icon class="mr-1"> mdi-file-pdf</v-icon> Descargar / Imprimir
          </v-btn>
          <!-- 59716 -->
          
 
          <v-btn color="orange" v-if="puedeFacturarBool && isispi && !recibo.factura_id" small rounded @click="openFacturaIspi(recibo)">
            <v-icon class="mr-1"> mdi-receipt</v-icon> Facturar.
          </v-btn>

          <div v-else-if="nitnotavailable">Facturacion no Disp.</div>

          <v-btn
            color="primary"
            v-else-if="(puedeFacturarBool && !isbenitojuarez) && (!recibo.factura_id)"
            v-show="!verifynit"
            small
            rounded
            @click="openEmitFactura(recibo, estudiante)"
          >
            <v-icon class="mr-1"> mdi-receipt</v-icon> {{ nitelectronico ? 'Factura E.' : 'Factura' }}
          </v-btn>
          <v-btn color="success" v-if="recibo.factura_id" small rounded @click="openFacturaPrint(recibo.factura_id)">
            <v-icon class="mr-1"> mdi-receipt</v-icon> {{ nitelectronico ? 'ver Factura E.' : 'ver Factura' }}
          </v-btn>
          
          

          <v-btn color="primary" v-if="puedeModificar" small rounded @click="openModifyRecibo(recibo)">
            <v-icon class="mr-1"> mdi-card </v-icon> Modificar Recibo
          </v-btn>

          <v-btn color="orange" v-if="$store.state.NETSUITE_VISIBLE && ($store.state.CARGO.id==14 || $store.state.CARGO.id==15 || $store.state.CARGO.id==1) && !recibo.netsuite_id" small rounded @click="openEnviarANetSuite()">
            <v-icon class="mr-1"> mdi-rotate-right-variant </v-icon> Enviar Netsuite
          </v-btn>
          <v-btn v-if="is_upi" color="orange darken-1" small dark rounded @click="open_duplicar_in_q10" title="duplicar estudiante en el Q10">
              Q10 <v-icon> mdi-open</v-icon>
          </v-btn>

          <!-- <v-tooltip bottom
            v-if="($store.state.CARGO.id==14 || $store.state.CARGO.id==15 || $store.state.CARGO.id==1) && !recibo.netsuite_id">
            <template #activator="{ on, attrs }">
              <v-icon class="ma-2" v-bind="attrs" @click="openEnviarANetSuite()" v-on="on" color="orange"> mdi-rotate-right-variant </v-icon>
            </template>
            
          </v-tooltip> -->
          <slot name="morebuttons"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <facturae-view ref="refEmitFacturae" @open="openFacturaPrint" />
    <factura-view ref="refEmitFactura" @open="openFacturaPrint" />
    <edit-data-recibo ref="refEditDataRecibo" @closeDialog="reloadRecibos" />
    <print-factura ref="refFacturaPrint" @fanulada="fanulada" :programa_id="programa ? programa.id : null" />
    <print-facturae
      ref="refFacturaePrint"
      :programa_id="programa ? programa.id : null"
      v-on:anuladofact="anuladofact"
      v-on:noFoundElectronica="noFoundElectronicaShowComputarizada"
    />

    <Confirm ref="refConfirm" v-on:enviado="$emit('reloadRecibos')"/>
    <crear_modal ref="refcrear_modal" v-on:fact_dgi_success="$emit('reloadRecibos',true)"/>
    <ver_factura_ispi ref="refver_factura_ispi" v-on:fact_dgi_desvinculado="$emit('reloadRecibos',true)"/>
    <modal_propuesta_duplicar ref="refmodal_propuesta_duplicar" />
  </v-row>
</template>

<script>
  import { jsPDF } from 'jspdf';
  import { Printd } from 'printd';
  import gql from 'graphql-tag';
  import 'jspdf-autotable';
  // https://www.npmjs.com/package/vue-html2pdf#getting-started
  import VueHtml2pdf from 'vue-html2pdf';

  import xaxios from '@/xaxios';
  import FacturaView from './EmitFacturaView.vue';
  import FacturaeView from './EmitFacturaEView.vue';
  import PrintFactura from './PrintFactura.vue';
  import PrintFacturae from './PrintFacturae.vue';
  import EditDataRecibo from './EditDataRecibo.vue';
  import Confirm from '@/components/AConfirmarNet.vue';
  import crear_modal from '../upi/factura_ispi/crear_modal.vue';
  import ver_factura_ispi from '../upi/factura_ispi/ver_factura_ispi.vue';
  import modal_propuesta_duplicar from '../upi/modal_propuesta_duplicar.vue';

  export default {
    components: { FacturaView, FacturaeView, PrintFactura, PrintFacturae, EditDataRecibo, VueHtml2pdf,Confirm,crear_modal,ver_factura_ispi,modal_propuesta_duplicar },
    data() {
      return {
        cssText: null,
        loading: false,
        verifynit: false,
        isispi: false,
        firma_path: process.env.VUE_APP_URL_BG_FIRMA_USER,
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        img_logo: process.env.VUE_APP_LOGO,
        app_name: process.env.VUE_APP_NAME,

        dialog: false,
        loading_recibo: false,
        isbenitojuarez: false,
        isfondobenito: false,
        isCcacorp: false,
        isWobi: false,
        msgnofact: '',
        msgfact: '',
        literal: '',
        headers: [
          { text: 'Concepto', value: 'concepto_name' },
          { text: 'N° Cuota', value: 'numero_cuota' },
          { text: 'Estado', value: 'estado' },
          { text: 'Monto', value: 'monto' },
        ],
        items: [],
        today: null,
        recibo: null,
        nitelectronico: false,
        nitnotavailable: false,
        estudiante: null,
        programa: null,
        asesor: null,
        sede: null,
        xsucursal: null,
        puedefacturar: false,
        formas_pago: [
          //FIXME: this array is static
          { id: 1, nombre: 'Efectivo', descripcion: 'Efectivo' },
          { id: 2, nombre: 'Transferencia  - Depósito', descripcion: 'Transferencia' },
        ],
        xnit: null,
        is_upi: false,
        data_rec: {
          fecha: 'Fecha Emision',
          valor: '????????',
          upi_emision: '',
          upi_emision_fecha: ''
        }
      };
    },
    computed: {
      puedeFacturarBool() {
        if (this.recibo) { 
          let cargoid = this.$store.state.CARGO.id; 
          if(cargoid==27) return false;

          let unidad = this.$store.state.CARGO.sede.unidad_negocio;
          if( unidad == 15 || unidad == 14){
            const a = this.recibo.fecha_registro.substr(0, 7)
            const b = this.today.substr(0, 7)
            let res = a === b;
            // window.console.log('puedeFacturarBool UPI',a,b);
            
            return res
          }

          let res = this.puedefacturar && this.recibo.fecha_registro.substr(0, 7) === this.today.substr(0, 7);
          // window.console.log('puedeFacturarBool: ',this.recibo.fecha_registro,this.today, res, this.puedefacturar);
          let ndate = new Date();
          let mes = ndate.getMonth();
          let dia = ndate.getDate();
          let hora = ndate.getHours();
          // para octubre, la firma se vencio, se esta habilitando que se pueda hasta cierto dia
          let idsede = this.$store.state.CARGO.sede.id;
          let scperm = idsede == 5 && mes == 9 && dia <= 4 && (hora==3 || hora==15);
          let scperm2 = idsede == 20 && mes == 9 && dia <= 7 && (hora==9 || hora==9);
          let scperm3 = idsede == 3 && !this.recibo.factura_id && this.puedefacturar && mes == 1;
          window.console.log('ndate',idsede,mes,dia,hora,scperm,scperm3,this.recibo);
          if(scperm2) return true;
          if(scperm3) return true;
          if(idsede == 7 && mes == 9 && dia <= 4) return true;
          if(scperm) return true;
          if(mes == 9 && dia <= 2 ) return true; 
          return res;
        }
        return false;
      },
      puedeModificar() {
        if (
          this.recibo &&
          this.recibo.estado &&
          (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14)
        ) {
          return true;
        }
        return false;
      },
      puedeImprimir() {
        if (this.recibo && this.recibo.estado) {
          return true;
        }
        return false;
      },
      isvisibledir() {
        if (!this.$store.state.CARGO) return false;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if (unidad == 3) return true;
        else return false;
      }, 
    },
    watch: {
      '$route.name': function() {
        this.isbenitojuarez = location.href.includes('recibosbenito');
        // if( this.isbenitojuarez ) this.isfondobenito = true;
      },
    },
    methods: {
      async showThisView(recibo = null, plan_pagos = []) {
        window.console.log('show recibo:', recibo);
        
        //this.parsexml();
        //this.getSedes();
        this.recibo = recibo;
        this.verificarIspiUnidad()
        this.verificar_is_upi()
        this.loading_recibo = true;
        this.getInscripcion(recibo.inscripcion_id);
        this.isfondobenito = false;
        this.isCcacorp = false;
        this.nitelectronico = false;
        this.nitnotavailable = false;
        this.isWobi = false;
        this.xnit = null; 
        plan_pagos = plan_pagos.length ? plan_pagos : await this.getPlan_pagos(recibo.inscripcion_id);
        const writtenNumber = require('written-number');
        await this.getFormasdePago(recibo);
        let formita = this.formas_pago.find((pago) => pago.id === recibo.forma_pago_id);
        //window.console.log('formita:', formita.nombre);
        if (formita) recibo.forma_pago = formita.nombre;
        recibo.total = 0;
        recibo.existedescuento = false;
        this.puedefacturar = recibo.factura_id ? false : true;
        if (recibo && recibo.detalle) {
          this.items = recibo.detalle;
          this.items.map((item, i = 0) => {
            if (item.cantidad == 0) item.cantidad = 1;
            if (!item.cantidad) item.cantidad = 1;
            item.index = i++;
            recibo.total += item.monto * item.cantidad;
            // item.numero_cuota = item.concepto.split(' - ')[1];
            item.numero_cuota = this.obtenerNumeroCuotaDelFinal(item.concepto);
            item.concepto_name = item.concepto.split(' - ')[0];
            let cuota = plan_pagos.find((pp) => pp.id == item.cuota_id);
            item.monto = parseFloat(Number(item.monto).toFixed(2))
            item.importe = cuota ? cuota.monto : 0;
            item.descuento = cuota ? cuota.descuento : 0;
            item.saldo = cuota ? cuota.saldo : 0;
            item.subtotal = parseFloat(Number(item.cantidad * item.monto).toFixed(2));
            item.fecha_de_pagar = cuota ? cuota.fecha_pago : '';
            return item;
          });
          //this.literal = writtenNumber(recibo.total, { lang: 'es' });
          let lit = writtenNumber(recibo.total, { lang: 'es' });
          if (lit.endsWith('ciento')) {
            lit = lit.replace('ciento', 'cien');
          }
          this.literal = lit;
          this.items.forEach((t) => {
            if (t.descuento > 0) {
              recibo.existedescuento = true;
              return;
            }
          });
          // window.console.log(JSON.stringify(this.items));
          this.msgnofact = '';
          this.items.forEach((t) => {
            if (!t.facturable) {
              this.puedefacturar = false;
              this.msgnofact = `AVISO: El concepto: '${t.concepto}' No es facturable.`;
              return;
            }
          });
        }
        this.recibo = recibo;
        // window.console.log('>>recibooo', this.recibo);
        
        this.dialog = true;
        //this.getInscripcion(recibo.inscripcion_id);
        this.getUsuario(recibo.emisor_id, recibo.sede_id);
        this.getSede(recibo.sede_id, recibo);
        this.loading_recibo = false;
      },
      async getFormasdePago(recibo) {
        //if (this.formas_pago.length > 0) return;
        let vue = this;
        vue.loadingformas = true;
        xaxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos`)
          .then(function(response) {
            let data = response.data.data;
            vue.formas_pago = data;
            vue.loadingformas = false;
            let formita = vue.formas_pago.find((pago) => pago.id === recibo.forma_pago_id);
            if (formita) recibo.forma_pago = formita.nombre;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingformas = false;
          });
      },
      capitalize(word) {
        if (!word) return '';
        if (word.length < 1) return word;
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      },
      openEmitFactura(recibo, estudiante) {
        //window.console.log('recibo:::', recibo, this.nitelectronico);
        if (this.nitnotavailable) return;

        if (this.nitelectronico) {
          this.$refs.refEmitFacturae.showThisView(recibo, estudiante, this.xsucursal, true, this.programa);
        } else {
          this.$refs.refEmitFactura.showThisView(recibo);
        }
      },
      fixeddecimal(d){
        try{ return d.toFixed(2) }
        catch{ ()=> d}
      },
      openModifyRecibo(recibo) {
        this.$refs.refEditDataRecibo.showThisView(recibo);
      },
      openFacturaPrint(factura_id, _, facturaelectro, cargautil) {
        if(this.isispi) {
          this.viewFacturaIspi()
          return;
        }
        this.recibo.factura_id = factura_id;
        this.puedefacturar = false;
        if (this.nitnotavailable) return;
        //let nitelectronico = false;
        //window.console.log('facturaelectro', facturaelectro);
        if (this.nitelectronico) {
          this.$refs.refFacturaePrint.showThisView(
            factura_id,
            this.recibo,
            facturaelectro,
            cargautil,
            this.xsucursal.apikey,
          );
          this.$emit('reloadRecibos'); // probar si actualiza los recibos
        } else {
          this.$refs.refFacturaPrint.showThisView(factura_id, this.recibo, null, {});
        }
      },
      noFoundElectronicaShowComputarizada(factura_id) {
        this.$refs.refFacturaPrint.showThisView(factura_id, this.recibo, null, {});
      },
      fanulada() {
        window.console.log('>>>>>>>>>>>>>>>>>>>>>> anulada');
        this.$set(this.recibo, 'factura_id', null);
        this.puedefacturar = false;
        this.closeDialog();
        this.$emit('reloadRecibos', false);
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      },
      getInscripcion(id) {
        this.verifynit = true;
        const sql = gql`query{getInscripcion(id: ${id}) { id estudiante{id, nombres, pri_apellido, seg_apellido, num_doc email domicilio} programa{id nombre_compuesto universidad{id nombre} sucursal{id nit{id nro}}} ${''}}}`;
        this.$apollo.query({ query: sql }).then(
          ({
            data: {
              getInscripcion: { estudiante, programa },
            },
          }) => {
            this.estudiante = estudiante;
            this.programa = programa;
            if (!programa.universidad) programa.universidad = {};
            if (programa.universidad.id == 128) this.isfondobenito = true;
            if (programa.universidad.id == 129) this.isCcacorp = true;
            if (programa.universidad.id == 130) this.isWobi = true;
            else {
              this.isfondobenito = false;
              this.isCcacorp = false;
              this.isWobi = false;
            }
            if (!programa.sucursal) programa.sucursal = { nit: {} };
            this.getnitbysucursal(programa.sucursal.id, programa.sucursal.nit.nro);
            this.verificar_is_upi()
            //window.console.log("><: ", programa);
          },
        );
      },
      getnitbysucursal(idsucursal, nronit) {
        window.console.log('idsucursal: ', idsucursal, ', nit: ', nronit);
        this.xsucursal = null;
        this.msgfact = '';
        if (!idsucursal) {
          this.nitelectronico = false;
          this.nitnotavailable = false;
          this.verifynit = false;
          if(!this.isispi){
            this.msgfact =
            'AVISO: El programa debe tener asignado una sucursal para poder verificar si corresponde la factura electronica.';
          }
          return;
        }
        const vue = this;
        var config = {
          method: 'get',
          url: `${this.api_rest}/api/v1/esam/sucursales/${idsucursal}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log('getnitbysucursal:', response.data);
            let data = response.data.tipo_facturacion;
            vue.xsucursal = response.data;
            vue.xnit = `${response.data.nit} ${data}`;
            if ((data + '').includes('ELECTR')) vue.nitelectronico = true;
            if ((data + '').includes('MANU')) vue.nitnotavailable = true;
            // para ck tambien, pero falta validar que solo ck igual sea la interfaz
            vue.nitelectronico = true;
            //if ((vue.xsucursal.nit + '').includes('4265269017')) vue.nitelectronico = true;
          })
          .catch(function(error) {
            window.console.log(error);
          });
        this.verifynit = false;
      },
      getPlan_pagos(inscripcion_id) {
        const url = `${this.api_rest}/api/esam/inscripcion/id/${inscripcion_id}`;
        return xaxios.get(url).then(({ data: { plan_pagos } }) => (plan_pagos ? plan_pagos : []));
      },
      getUsuario(id, sede_id) {
        window.console.log('*-*-*-*-*:::', id, sede_id);
        const sql = gql`query{getUsuario(id: ${id}) { id firma cargos{ idusuario,idsede,idcargo, cargo {id, nombre}} datos_personales{ num_doc nombres pri_apellido seg_apellido} ${''}}}`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          this.asesor = data.getUsuario; 
          if (!this.asesor) this.asesor = { cargos: [],datos_personales:{} };
          else {
            this.asesor.cargo = this.asesor.cargos.find((cargo) => cargo.idsede == sede_id).cargo;
          }
          //window.console.log('------', this.asesor);
        });
      },
      getfondoimg() {
        if (this.isfondobenito) this.sede.modelo_recibo = 'img/recibolatam.png';
        if (this.isCcacorp) this.sede.modelo_recibo = 'img/reciboccacorp.png';
        if (this.isWobi) this.sede.modelo_recibo = 'img/recibowobi.png';
        return this.sede.modelo_recibo;
      },
      getSede(id, recibo) {
        // window.console.log(recibo);
        const sql = gql`query{getSede(id: ${id}) { id nombre nombre_recibo modelo_recibo direccion telefono1 cuentasBancarias {id nombre nro descripcion estado} ${''}}}`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          this.sede = data.getSede;
          this.sede.cuenta_bancaria =
            recibo && recibo.cuenta_bancaria_id
              ? this.sede.cuentasBancarias.find(({ id }) => id == recibo.cuenta_bancaria_id)
              : null;
          this.sede.modelo_recibo = process.env.VUE_APP_URL_BG_RECIBO_SEDE + this.sede.modelo_recibo;
        });
      },
      generateReport() {
        this.$refs.html2Pdf.generatePdf();
      },
      download() {
        var g_recibo = this.recibo;
        var g_student = this.estudiante;
        this.loading = true;
        let doc = new jsPDF('p', 'pt', 'letter');
        doc
          .html(document.getElementById('html'), {
            callback: function(doc) {
              window.console.log(doc);
              this.loading = false;
              doc.save(
                `${g_recibo.numero_recibo} ${g_student.pri_apellido} ${g_student.seg_apellido} ${g_student.nombres}.pdf`,
              );
            },
            x: 10,
            y: 10,
          })
          .then(() => {
            this.closeDialog();
          });
      },
      printRecibo() {
        const d = new Printd();
        // const { contentWindow } = d.getIFrame();
        // contentWindow.addEventListener('beforeprint', () => window.console.log('before print event!'));
        // contentWindow.addEventListener('afterprint', () => window.console.log('after print event!'));
        d.print(document.getElementById('html'), [this.cssText]);
      },
      reloadRecibos() {
        this.closeDialog();
        this.$emit('reloadRecibos');
      },
      closeDialog() {
        this.loading = false;
        this.dialog = false;
        this.puedefacturar = false;
        this.items = [];
        this.recibo = null;
        this.programa = null;
        this.estudiante = null;
        this.asesor = null;
        this.sede = null;
        this.total = 0;
        this.$emit('closeDialogShow', true);
      },
      anuladofact() {
        // anular la facturaid de recibos con el endpoint
        this.recibo.factura_id = null;
        this.puedefacturar = true;
        this.guardarFacturaNulRecibo(null, this.recibo.id);
      },
      guardarFacturaNulRecibo(idfactura, idrecibo) {
        let vue = this;
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/addfactura`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            recibo_id: idrecibo,
            factura_id: idfactura,
            numero_factura: null,
            nit: null,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('guardarFacturaNulRecibo::: ', data);
            vue.$emit('reloadRecibos');
          })
          .catch(function(error) {
            let data = error.response.data;
            window.console.log(data);
          });
      },

      parsexmlvalue(xmlDoc, key) {
        try {
          //return xmlDoc.getElementsByTagName(key)[0].childNodes[0].nodeValue;
          xmlDoc.getElementsByTagName(key).forEach((i) => {
            i.childNodes.forEach((x) => {
              window.console.log('x', x);
            });
          });
          return xmlDoc.getElementsByTagName(key)[0].childNodes[0];
        } catch (e) {
          return '';
        }
      },
      parsexml() {
        let factura = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?><facturaElectronicaSectorEducativo><cabecera><nitEmisor>4265269017</nitEmisor><razonSocialEmisor>CARI QUISPE SEVERINO FELIX</razonSocialEmisor><municipio>tarija</municipio><telefono xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><numeroFactura>644</numeroFactura><cuf>123D76FC186A171FA922F24706A1A041B99CA442A821A657F544776D74</cuf><cufd>QsKhQsK/MWFFQQ==Q0VFOTg4N0Y2NzY=QkEyUGVJQkdXVUFBNzFGMzkxRTNGODM0</cufd><codigoSucursal>1</codigoSucursal><direccion>CALLE COLON, ENTRE BOLIVAR Y AV. DOMINGO PAZ NRO. 888, EDIFICIO ORTIZ PISO 2, ZONA/BARRIO LA PAMPA, TARIJA</direccion><codigoPuntoVenta xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><fechaEmision>2022-05-31T15:03:35.168Z</fechaEmision><nombreRazonSocial>Diego Armando Saldias Villarroel</nombreRazonSocial><codigoTipoDocumentoIdentidad>1</codigoTipoDocumentoIdentidad><numeroDocumento>10721310</numeroDocumento><complemento xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><codigoCliente>3</codigoCliente><nombreEstudiante>Diego Armando Saldias Villarroel</nombreEstudiante><periodoFacturado>JUNIO</periodoFacturado><codigoMetodoPago>1</codigoMetodoPago><numeroTarjeta xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><montoTotal>1500</montoTotal><montoTotalSujetoIva>1500</montoTotalSujetoIva><codigoMoneda>1</codigoMoneda><tipoCambio>1</tipoCambio><montoTotalMoneda>1500</montoTotalMoneda><montoGiftCard xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><descuentoAdicional xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><codigoExcepcion xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><cafc xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><leyenda>Ley Nro. 453: Esta prohibido importar, distribuir o comercializar productos expirados o prontos a expirar.</leyenda><usuario>Usuario Administrador </usuario><codigoDocumentoSector>11</codigoDocumentoSector></cabecera><detalle><actividadEconomica>853000</actividadEconomica><codigoProductoSin>99100</codigoProductoSin><codigoProducto>2</codigoProducto><descripcion>Colegiatura</descripcion><cantidad>1</cantidad><unidadMedida>25</unidadMedida><precioUnitario>700</precioUnitario><montoDescuento xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><subTotal>700</subTotal></detalle><detalle><actividadEconomica>853000</actividadEconomica><codigoProductoSin>99100</codigoProductoSin><codigoProducto>2</codigoProducto><descripcion>Colegiatura</descripcion><cantidad>1</cantidad><unidadMedida>25</unidadMedida><precioUnitario>700</precioUnitario><montoDescuento xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><subTotal>700</subTotal></detalle><detalle><actividadEconomica>853000</actividadEconomica><codigoProductoSin>99100</codigoProductoSin><codigoProducto>2</codigoProducto><descripcion>Colegiatura</descripcion><cantidad>1</cantidad><unidadMedida>25</unidadMedida><precioUnitario>100</precioUnitario><montoDescuento xsi:nil="true" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"/><subTotal>100</subTotal></detalle></facturaElectronicaSectorEducativo>`;
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(factura, 'text/xml');

        window.console.log('\n\n>>>', this.parsexmlvalue(xmlDoc, 'detalle'));
      },
      gettext_posgrado() {
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        //window.console.log(unidad);
        if (unidad == 2 || unidad == 3) return 'curso';
        else return 'posgrado';
      },
      getSedes() {
        this.$apollo
          .query({
            query: gql`query{getSedes{id,nombre} ${''}}`,
          })
          .then((data) => {
            var dat = data.data.getSedes;
            window.console.log('getSedes:> ', dat);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      getMonedaStr(){
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(unidad==14 || unidad == 15) return 'dolares';
        return 'bolivianos';
      },
      openEnviarANetSuite(){
        this.$refs.refConfirm.openmodal(this.recibo); 
      },
      getStylePrint(){
        const t = this.items.length;
        window.console.log('ttttttttttt',t);
        if(t >= 20) return 'font-size:0.5em!important;'
        return ''
      },
      obtenerNumeroCuotaDelFinal(conceptoStr) {
        if (typeof conceptoStr !== 'string' || conceptoStr.trim() === '') {
          return NaN;
        } 
        const partes = conceptoStr.split(' - '); 
        const ultimaParte = partes.pop(); 
        const numeroCuota = parseInt(ultimaParte, 10);

        return numeroCuota;
      },
      openFacturaIspi(r){
        /* let apidev = process.env.VUE_APP_GRAPHQL;
        if( !apidev.includes("apidev") ){
          window.alert('facturacion en desarrollo :) ')
        }else{
          this.$refs.refcrear_modal.openmodal(r,this.xsucursal, this.estudiante, this.programa)
        } */
       this.$refs.refcrear_modal.openmodal(r,this.xsucursal, this.estudiante, this.programa)
      },
      viewFacturaIspi(){ 
        this.$refs.refver_factura_ispi.openmodal(this.recibo)
      },
      verificar_is_upi(){
        const u = this.$store.state.CARGO.sede.unidad_negocio 
        this.is_upi = u == 15 
        if(this.is_upi) {
          this.data_rec.fecha = 'Fecha de pago'
          this.data_rec.valor = this.recibo?.fecha_pago;
          this.data_rec.upi_emision = 'Fecha de Emision';
          this.data_rec.upi_emision_fecha = this.recibo?.fecha_registro;
        }else{
          this.data_rec.fecha = 'Fecha Emision'
          this.data_rec.valor = this.recibo?.fecha_registro;
          this.data_rec.upi_emision = '';
          this.data_rec.upi_emision_fecha = '';
        }
      },
      open_duplicar_in_q10(){ 
        const prog = Object.assign({}, this.programa);
        prog.programa_id = prog.id
        this.$refs.refmodal_propuesta_duplicar.openmodal(prog,this.estudiante) 
      },
      verificarIspiUnidad(){
        const u = this.$store.state.CARGO.sede.unidad_negocio 
        this.isispi = u == 14 || u == 15
      }
    },
    mounted() {
      this.verificarIspiUnidad()
      this.isbenitojuarez = location.href.includes('recibosbenito');
      const [day, month, year] = new Date()
        .toLocaleString('es-US', {
          timeZone: 'America/La_Paz',
          year: 'numeric',
          day: '2-digit',
          month: '2-digit',
        })
        .split('/');
      this.today = `${year}-${month}-${day}`;
      // window.console.log('today date show.vue', this.today, this.today.substr(0, 7));

      this.cssText = `
      table {
        border-collapse: collapse;
        border-spacing: 0; 
    }

      .v-card__subtitle,
      .v-card__text {
          font-size: .875rem;
          font-weight: 400;
          line-height: 1.375rem;
          letter-spacing: .0071428571em;
      }

      .theme--light.v-card .v-card__subtitle,
      .theme--light.v-card>.v-card__text {
          color: rgba(0, 0, 0, .6);
      }

      .mb-0 {
          margin-bottom: 0 !important;
      }

      .pb-0 {
          padding-bottom: 0 !important;
      }

      .container,
      .container-fluid {
          padding-left: 15px;
          margin-right: auto;
          margin-left: auto;
          
      }


      .col-3 {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 25%;
          flex: 0 0 25%;
          max-width: 25%;
      }

      .carousel-inner>.item>a>img,
      .carousel-inner>.item>img,
      .img-responsive,
      .thumbnail a>img,
      .thumbnail>img {
          display: block;
          max-width: 100%;
          max-height: auto;
      }

      img {
          border-style: none;
          border: 0;
          vertical-align: middle;
      }

      .col-9 {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 75%;
          flex: 0 0 75%;
          max-width: 75%;
      }

      .my-0 {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
      }

      .py-0 {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
      }

      .theme--light.v-divider {
          border-color: rgba(0, 0, 0, .12);
      }
      pa-1{
        padding: 1em;
      }

      .pt-1 {
          padding-top: 4px !important;
      }

      .row {
          --bs-gutter-x: 1.5rem;
          --bs-gutter-y: 0;
          display: flex;
          flex-wrap: wrap;
          margin-top: calc(var(--bs-gutter-y) * -1);
          margin-right: calc(var(--bs-gutter-x) / -2);
          margin-left: calc(var(--bs-gutter-x) / -2);
      }

      .row>* {
          box-sizing: border-box;
          flex-shrink: 0;
          width: 100%;
          max-width: 100%;
          padding-right: calc(var(--bs-gutter-x) / 2);
          padding-left: calc(var(--bs-gutter-x) / 2);
          margin-top: var(--bs-gutter-y);
      }

      .col {
          flex: 1 0 0%;
      }

      .col,
      .col-1,
      .col-2,
      .col-3,
      .col-4,
      .col-5,
      .col-6,
      .col-7,
      .col-8,
      .col-9,
      .col-10,
      .col-11,
      .col-12,
      .col-auto,
      .col-lg,
      .col-lg-1,
      .col-lg-2,
      .col-lg-3,
      .col-lg-4,
      .col-lg-5,
      .col-lg-6,
      .col-lg-7,
      .col-lg-8,
      .col-lg-9,
      .col-lg-10,
      .col-lg-11,
      .col-lg-12,
      .col-lg-auto,
      .col-md,
      .col-md-1,
      .col-md-2,
      .col-md-3,
      .col-md-4,
      .col-md-5,
      .col-md-6,
      .col-md-7,
      .col-md-8,
      .col-md-9,
      .col-md-10,
      .col-md-11,
      .col-md-12,
      .col-md-auto,
      .col-sm,
      .col-sm-1,
      .col-sm-2,
      .col-sm-3,
      .col-sm-4,
      .col-sm-5,
      .col-sm-6,
      .col-sm-7,
      .col-sm-8,
      .col-sm-9,
      .col-sm-10,
      .col-sm-11,
      .col-sm-12,
      .col-sm-auto,
      .col-xl,
      .col-xl-1,
      .col-xl-2,
      .col-xl-3,
      .col-xl-4,
      .col-xl-5,
      .col-xl-6,
      .col-xl-7,
      .col-xl-8,
      .col-xl-9,
      .col-xl-10,
      .col-xl-11,
      .col-xl-12,
      .col-xl-auto {
          width: 100%;
          padding: 12px;
      }

      .text-right {
          text-align: right !important;
      }

      .pa-2 {
          padding: 8px !important;
      }
      td {
          vertical-align: middle !important;
      }

      .text-center {
          text-align: center !important;
      }
.item-table {
  border: 1px solid silver;
  width: 98%; 
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500;
  line-height: 1.2;
  color: #317eac;
}

.item-td,
.item-th {
  /* padding: 5px; */
  border: 1px solid silver;
}
.item-tr {
  height: 10px;
}

.page-break {
  page-break-before: after;
  page-break-inside: avoid;
}
.flexcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: row;
  padding-right: 5%;
}
.border-box {
  border: solid 1px #4d84c7c7;
  border-radius: 0.4em;
  margin-bottom: 10px;
}
.flexitem {
  margin-right: 0.3em;
  margin-left: 0.3em;
  margin-bottom: 0.1em;
  display: inline-flex;
  vertical-align: middle;
  justify-content: space-around;
}

.r-box {
  font-size: 0.8em;
  /* float: left; */
  line-height: 1.5;
  padding: 0.2em 0.5em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.r-title2 {
  font-weight: bold;
  color: #305077;
  background-color: rgba(237, 252, 255, 0.705);
  /* border-radius: 0.3em 0 0 0.3em; */
  /* border-right: 1px solid; */
}
.r-title3 {
  font-weight: bold;
  color: #305077;
  font-size: 0.8em;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.r-text {
  background-color: rgb(253, 253, 253);
  border-radius: 0 0.3em 0.3em 0;
}
.recibo-number {
  font-weight: bold;
  color: #305077;
  padding: 0.2em 1rem;
  font-size: 1.2rem;
}
.firma-responsive {
  margin-left: auto;
  margin-right: auto;
  max-height: 61px;
  max-width: 150px;
}
.firma-box {
  border-bottom: 1px solid #305077;
  border-bottom-style: dotted;
  min-height: 60px;
}
.max-heigh{
  max-height: 100px;
}
.w-98{
  max-width: 98%;
}
.w-95{
  max-width: 95%;
}
.rotate {
  height: 0;
  transform: rotate(-45deg);
  /* Legacy vendor prefixes that you probably don't need... */
  /* Safari */
  -webkit-transform: rotate(-45deg);
  /* Firefox */
  -moz-transform: rotate(-45deg);
  /* IE */
  -ms-transform: rotate(-45deg);
  /* Opera */
  -o-transform: rotate(-45deg);
  /* Internet Explorer */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}
.anulado {
  font-size: xx-large;
  color: rgb(197 49 49);
  font-weight: bold;
}
@media print {
  .d-print-none {display: none !important}
}
`;
    },
  };

  // tipo de pago
</script>
<style scoped>
  .item-table {
    border: 1px solid silver;
    width: 98%;
  }
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 500;
    line-height: 1.2;
    color: #317eac;
  }

  .item-td,
  .item-th {
    /* padding: 5px; */
    border: 1px solid silver;
  }
  .item-tr {
    height: 10px;
  }

  .page-break {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
  .flexcontainer {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    flex-direction: row;
    padding-right: 5%;
  }
  .border-box {
    border: solid 1px #4d84c7c7;
    border-radius: 0.4em;
    margin-bottom: 10px;
    /* box-shadow: 3px 3px 8px 0px rgba(0, 0, 0, 0.3); */
  }
  .flexitem {
    margin-right: 0.3em;
    margin-left: 0.3em;
    margin-bottom: 0.1em;
    display: inline-flex;
    vertical-align: middle;
    justify-content: space-around;
  }

  .r-box {
    font-size: 0.8em;
    /* float: left; */
    line-height: 1.5;
    padding: 0.2em 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .r-title2 {
    font-weight: bold;
    color: #305077;
    background-color: rgba(237, 252, 255, 0.705);
    /* border-radius: 0.3em 0 0 0.3em; */
    /* border-right: 1px solid; */
  }
  .r-title3 {
    font-weight: bold;
    color: #305077;
    font-size: 0.8em;
    line-height: 1.5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .r-text {
    background-color: rgb(253, 253, 253);
    border-radius: 0 0.3em 0.3em 0;
  }
  .recibo-number {
    font-weight: bold;
    color: #305077;
    padding: 0.2em 1rem;
    font-size: 1.2rem;
  }
  .firma-responsive {
    margin-left: auto;
    margin-right: auto;
    max-height: 61px;
    max-width: 150px;
  }
  .firma-box {
    border-bottom: 1px solid #305077;
    border-bottom-style: dotted;
    min-height: 60px;
  }
  .max-heigh {
    max-height: 100px;
  }
  .w-98 {
    max-width: 98%;
  }
  .w-95 {
    max-width: 95%;
  }
  .rotate {
    height: 0;
    transform: rotate(-45deg);
    /* Legacy vendor prefixes that you probably don't need... */
    /* Safari */
    -webkit-transform: rotate(-45deg);
    /* Firefox */
    -moz-transform: rotate(-45deg);
    /* IE */
    -ms-transform: rotate(-45deg);
    /* Opera */
    -o-transform: rotate(-45deg);
    /* Internet Explorer */
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  }
  .anulado {
    font-size: xx-large;
    color: rgb(197 49 49);
    font-weight: bold;
  }
</style>
